import { useQuery } from "@tanstack/react-query";

import { getStreams } from "@/api/matches";
import { MatchesQueryKeys } from "./matchesQueryKeys";

interface Options {
  providerId: number;
  providerMatchId: number;
}

export const useGetStreams = (options: Options) => {
  return useQuery({
    queryKey: [
      MatchesQueryKeys.Streams,
      options.providerId,
      options.providerMatchId,
    ],
    enabled: true,
    queryFn: async ({ signal }) => {
      return await getStreams({ params: options, signal });
    },
  });
};
